import React from 'react';

const GamblingWarning: React.FC = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-red-900/95 border-b-2 border-red-700 py-1.5 md:py-2 px-2 md:px-4 text-center">
      <p className="text-white text-[10px] md:text-xs lg:text-sm font-medium leading-tight">
        <strong>JEUX D'ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX:</strong> PERTES D'ARGENT, CONFLITS FAMILIAUX, ADDICTION.{' '}
        RETROUVEZ NOS CONSEILS SUR{' '}
        <a
          href="https://www.joueurs-info-service.fr/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-yellow-300 hover:text-yellow-200 underline font-semibold"
        >
          JOUEURS-INFO-SERVICE.FR
        </a>{' '}
        <span className="hidden sm:inline">(09 74 75 13 13 - APPEL NON SURTAXÉ)</span>
        <span className="sm:hidden">(09 74 75 13 13)</span>
      </p>
    </div>
  );
};

export default GamblingWarning;

